import { REMOVE_APPROVER_REQUEST, REMOVE_APPROVER_SUCCESS, REMOVE_APPROVER_FAILURE, REMOVE_APPROVER_RESET, } from "../../actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const removeApproverReducer = (state = initialState, action) => {
    switch (action.type) {
        case REMOVE_APPROVER_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, error: null });
        case REMOVE_APPROVER_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case REMOVE_APPROVER_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        case REMOVE_APPROVER_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default removeApproverReducer;
